import React, { useEffect } from "react";
import { Col, Form, Row, Input, Button, Tooltip, Space } from "antd";
import {
  CloseCircleOutlined,
  SafetyOutlined,
  SearchOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import RoleSearch from "../common/RoleSearch";
import GroupInRoleSearch from "../common/GroupInRoleSearch";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getGroupById, getRoleForApplication } from "../../actions/api";

const RoleFormItemComponent = ({
  form,
  label,
  name,
  searchLabel,
  applicationId,
  required = false,
  getRoleForApplication,
}) => {
  const enabledField = Form.useWatch(name, form);

  useEffect(() => {
    async function fetchRoleName(applicationId, roleId) {
      const action = await getRoleForApplication(applicationId, roleId);
      form.setFieldsValue({
        [`${name}-resolved`]: action?.payload?.data?.name,
      });
    }

    if (enabledField) fetchRoleName(applicationId, enabledField);
  }, [enabledField, form, getRoleForApplication, applicationId, name]);

  return (
    <Form.Item label={label} style={{ marginBottom: "0px" }}>
      <Row gutter={4}>
        <Col span={22}>
          <Form.Item hidden name={name} rules={[{ required: required }]}>
            <Input placeholder="Role ID" />
          </Form.Item>
          <Form.Item disabled name={`${name}-resolved`}>
            <Input
              disabled
              prefix={<SafetyOutlined />}
              style={{ color: "black" }}
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Space direction="horizontal">
            <Tooltip title="Clear field">
              <Button
                onClick={() => {
                  form.setFieldsValue({
                    [name]: undefined,
                    [`${name}-resolved`]: undefined,
                  });
                }}
                icon={<CloseCircleOutlined />}
              />
            </Tooltip>
            <RoleSearch
              title={searchLabel}
              applicationId={applicationId}
              icon={<SearchOutlined />}
              onSelect={(role) => {
                form.setFieldsValue({
                  [name]: role.id,
                });
              }}
            />
          </Space>
        </Col>
      </Row>
      <Row gutter={4}>
        <Col span={22}></Col>
        <Col span={2}></Col>
      </Row>
    </Form.Item>
  );
};

RoleFormItemComponent.propTypes = {
  form: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  searchLabel: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  required: PropTypes.bool,
  getRoleForApplication: PropTypes.func.isRequired,
};

export const RoleFormItem = connect(() => ({}), { getRoleForApplication })(
  RoleFormItemComponent,
);

const GroupFormItemComponent = ({
  form,
  label,
  name,
  searchLabel,
  tooltip,
  applicationId,
  roleId,
  required = false,
  getGroupById,
}) => {
  const enabledField = Form.useWatch(name, form);

  useEffect(() => {
    async function fetchGroupName(groupId) {
      const action = await getGroupById(groupId);
      form.setFieldsValue({
        [`${name}-resolved`]: action?.payload?.data?.groupIdentifier,
      });
    }
    if (enabledField) fetchGroupName(enabledField);
  }, [enabledField, form, getGroupById, name]);

  return (
    <Form.Item label={label} style={{ marginBottom: "0px" }} tooltip={tooltip}>
      <Row gutter={4}>
        <Col span={22}>
          <Form.Item hidden name={name} rules={[{ required: required }]}>
            <Input placeholder="Group ID" />
          </Form.Item>
          <Form.Item disabled name={`${name}-resolved`}>
            <Input
              disabled
              prefix={<UsergroupAddOutlined />}
              style={{ color: "black" }}
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Space direction="horizontal">
            <Tooltip title="Clear field">
              <Button
                onClick={() => {
                  form.setFieldsValue({
                    [name]: undefined,
                    [`${name}-resolved`]: undefined,
                  });
                }}
                icon={<CloseCircleOutlined />}
              />
            </Tooltip>
            <GroupInRoleSearch
              title={searchLabel}
              applicationId={applicationId}
              roleId={roleId}
              icon={<SearchOutlined />}
              onSelect={(group) => {
                form.setFieldsValue({
                  [name]: group.id,
                });
              }}
            />
          </Space>
        </Col>
      </Row>
    </Form.Item>
  );
};

GroupFormItemComponent.propTypes = {
  form: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  searchLabel: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  applicationId: PropTypes.string.isRequired,
  roleId: PropTypes.string,
  required: PropTypes.bool,
  getGroupById: PropTypes.func.isRequired,
};

export const GroupFormItem = connect(() => ({}), { getGroupById })(
  GroupFormItemComponent,
);

export const selectHasRole = (role) => (state) => {
  const kcInstance = state.keycloak.instance;
  if (kcInstance.tokenParsed && kcInstance.tokenParsed.cern_roles) {
    return kcInstance.tokenParsed.cern_roles.includes(role);
  }
  return false;
};
